import { useTranslation } from 'react-i18next';

export default function ServicesDirectory() {
  const { t } = useTranslation();
  const servicesList = t('services.dir.servicesList', { returnObjects: true }) as string[];
  const workList = t('services.dir.workList', { returnObjects: true }) as string[];
  const areasList = t('services.dir.areasList', { returnObjects: true }) as string[];

  return (
    <section className="bg-warm-white py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="mb-14">
          <span className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium">{t('services.dir.badge')}</span>
          <div className="w-10 h-px bg-sage mt-3" />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-8">
          <div>
            <h3 className="font-inter font-semibold text-xs uppercase tracking-widest text-charcoal mb-6">{t('services.dir.offered')}</h3>
            <ul className="flex flex-col gap-3">
              {servicesList.map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm text-text-muted font-inter">
                  <span className="w-1.5 h-1.5 rounded-full bg-sage flex-shrink-0 mt-0.5" />{item}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:border-x border-sage/10 lg:px-8">
            <h3 className="font-inter font-semibold text-xs uppercase tracking-widest text-charcoal mb-6">{t('services.dir.worksWith')}</h3>
            <ul className="flex flex-col gap-3">
              {workList.map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm text-text-muted font-inter">
                  <span className="w-1.5 h-1.5 rounded-full bg-sage flex-shrink-0 mt-0.5" />{item}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-inter font-semibold text-xs uppercase tracking-widest text-charcoal mb-6">{t('services.dir.areas')}</h3>
            <ul className="flex flex-col gap-3 mb-8">
              {areasList.map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm text-text-muted font-inter">
                  <span className="w-1.5 h-1.5 rounded-full bg-sage flex-shrink-0 mt-0.5" />{item}
                </li>
              ))}
            </ul>
            <div className="bg-warm-white border border-sage/20 rounded-xl px-5 py-4 inline-flex items-center gap-3">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-verified-badge-line text-sage" />
              </div>
              <div>
                <p className="text-xs text-text-muted font-inter">{t('services.dir.profTitle')}</p>
                <p className="text-sm font-inter font-semibold text-charcoal">{t('services.dir.groupAnalyst')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
